/**
 * @file Ask
 * @author 丁聪
 */

import React, { Component } from 'react'
import { postJoin } from 'src/apis/user'
import { message } from 'antd'

import './index.scss'

class Ask extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Name: '',
            Phone: '',
            Wechat: '',
            Email: '',
            City: '',
            Institutions: '',
            Peoples: '',
        };
    }

    handleName = (e) => {
        let Name = e.target.value
        this.setState({ Name })
    }

    handlePhone = (e) => {
        let Phone = e.target.value
        this.setState({ Phone })
    }

    handleWechat = (e) => {
        let Wechat = e.target.value
        this.setState({ Wechat })
    }

    handleEmail = (e) => {
        let Email = e.target.value
        this.setState({ Email })
    }

    handleContry = (e) => {
        let City = e.target.value
        this.setState({ City })
    }

    handleOrg = (e) => {
        let Institutions = e.target.value
        this.setState({ Institutions })
    }

    handleScale = (e) => {
        let Peoples = e.target.value
        this.setState({ Peoples })
    }

    handleSubmit = () => {
        let {
            Name,
            Phone,
            Wechat,
            Email,
            City,
            Institutions,
            Peoples
        } = this.state;
        console.log(Name, Phone, Wechat, Email, City, Institutions, Peoples);
        if (Name && Phone && Wechat && Email && City && Institutions && Peoples) {
            postJoin({ Name, Phone, Wechat, Email, City, Institutions, Peoples }).then(res => {
                // console.log(res);
                message.success('提交成功')
            })
        } else {
            message.error('表单内容不为空')
        }
    }

    componentDidMount() { }

    render() {
        return (
            <div id="askFor">
                <div className="make-title">合作联系</div>
                <div className="heng"></div>
                <div className="log">
                    <div className="intro">
                        <input type="text" onChange={this.handleName} className="intro-a" placeholder='姓名' />
                        <input type="text" onChange={this.handlePhone} className="intro-a" placeholder='手机号' />
                        <input type="text" onChange={this.handleWechat} className="intro-a" placeholder='微信/facebook/WhatsApp' />
                        <input type="text" onChange={this.handleEmail} className="intro-a" placeholder='邮箱(Email)' />
                        <input type="text" onChange={this.handleContry} className="intro-a" placeholder='所在国家/城市' />
                        <input type="text" onChange={this.handleOrg} className="intro-a" placeholder='机构名称(选填)' />
                        <input type="text" onChange={this.handleScale} className="intro-a" placeholder='机构规模(选填)' />

                        <button onClick={this.handleSubmit} className="but">提交申请</button>
                    </div>
                </div>

            </div>

        )
    }
}

export default Ask
